module.exports = __webpack_public_path__ + "img/aero-shot-5.a1137562.webp";